import { PureComponent } from "react";
import ReactGA from "react-ga";
import { CriteoProductpage } from '../actions/analytics';

class AnalyticsTracking extends PureComponent {

  componentDidMount() {

      const trackingID = (process.env.REACT_APP_ENV === 'development')  ? 'UA-000000-01' : 'UA-996506-14';
      const debugMode = (process.env.REACT_APP_ENV === 'development') ? true : false;
      
      if (process.env.REACT_APP_ENV === "production" || process.env.REACT_APP_TRACKING_DEBUG === "true") {
        ReactGA.initialize(trackingID, { debug: debugMode });

        this.sendPageView();
        this.props.history.listen(this.sendPageView)
      }
  }

  sendPageView() {

    //Google analytics
    ReactGA.pageview("book.busabout.com" + window.location.pathname + window.location.search);

    //Criteo tracking
    if( window.location.pathname.substring(0, window.location.pathname.lastIndexOf('/')) === '/basket' ){
      CriteoProductpage(window.location.pathname.substring(window.location.pathname.lastIndexOf('/') + 1, window.location.pathname.length));
    }

  }

  render() {
    return (null);
  }
}

export default AnalyticsTracking;



// WEBPACK FOOTER //
// ./src/helpers/AnalyticsTracking.js